export default "__VITE_PUBLIC_ASSET__61e9d6f1__"